// Kategori recipient untuk Payment Allocation Simulator.
// Harus sinkron dengan RECIPIENT_TYPES di backend (utils/paymentAllocation.js).

export const RECIPIENT_TYPES = {
  PIC: "PIC",
  STUDENT: "Student",
  OTHER_EMAIL: "Other Email",
  CEA: "CEA",
};

// Semua kategori yang boleh dipilih (maksimal 4, tidak boleh duplikat).
export const ALL_RECIPIENT_TYPES = [
  RECIPIENT_TYPES.PIC,
  RECIPIENT_TYPES.STUDENT,
  RECIPIENT_TYPES.OTHER_EMAIL,
  RECIPIENT_TYPES.CEA,
];

// Kategori yang admin bisa tambah manual (CEA otomatis, tidak lewat dropdown).
export const SELECTABLE_RECIPIENT_TYPES = [
  RECIPIENT_TYPES.PIC,
  RECIPIENT_TYPES.STUDENT,
  RECIPIENT_TYPES.OTHER_EMAIL,
];

export const DISCOUNT_OPTIONS = [0, 25, 50, 75, 100];

// Persentase recipient hanya kelipatan 25.
export const PERCENT_OPTIONS = [0, 25, 50, 75, 100];
